"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = __importDefault(require("../Typography"));
exports.RadioButton = react_1.forwardRef((_a, ref) => {
    var { id, className, label, textClassName, isInline = true, disabled, alignItems = 'start' } = _a, restProps = __rest(_a, ["id", "className", "label", "textClassName", "isInline", "disabled", "alignItems"]);
    const radioButtonBaseClassName = 'bds-c-radio-button';
    const radioButtonIsInlineClassName = isInline
        ? `${radioButtonBaseClassName}--inline`
        : `${radioButtonBaseClassName}--block`;
    const radioButtonAlignItemsClassName = alignItems
        ? `${radioButtonBaseClassName}--align-items-${alignItems}`
        : '';
    const radioButtonIsDisabledClassName = disabled
        ? 'bds-is-disabled'
        : '';
    const radioButtonClassName = classnames_1.default(radioButtonBaseClassName, radioButtonIsDisabledClassName, radioButtonIsInlineClassName, radioButtonAlignItemsClassName, className);
    const radioButtonTextClassName = classnames_1.default(`${radioButtonBaseClassName}__text`, textClassName);
    return (react_1.default.createElement("label", { className: radioButtonClassName, id: `${id}-label` },
        react_1.default.createElement("input", Object.assign({ id: id, className: `${radioButtonBaseClassName}__input`, type: 'radio', ref: ref, disabled: disabled }, restProps)),
        react_1.default.createElement("span", { className: `${radioButtonBaseClassName}__icon` },
            react_1.default.createElement("span", { className: `${radioButtonBaseClassName}__icon-checked` },
                react_1.default.createElement("span", { className: `${radioButtonBaseClassName}__icon-checked__inner` })),
            react_1.default.createElement("span", { className: `${radioButtonBaseClassName}__icon-unchecked` })),
        react_1.default.createElement(Typography_1.default, { className: radioButtonTextClassName, as: 'span', type: 'label-md' }, label)));
});
exports.RadioButton.displayName = 'RadioButton';
exports.default = exports.RadioButton;
